export const urlcode = 'https://cardapi.sjhlwyy.com'//正式
// export const urlcode = 'http://192.168.40.19:1088/card'  //fqf
localStorage.setItem('urlcode', urlcode);
export default {urlcode}
















// WEBPACK FOOTER //
// ./src/config.js